module.exports = __webpack_public_path__ + "static/media/logowhiteoutline.94cc2adf.png";